import FormControl from '@mui/material/FormControl';
import styled from 'styled-components';

export const AutocompleteFormControl = styled(FormControl)`
    .MuiAutocomplete-popupIndicator {
        transform: rotate(270deg);

        &:hover {
            opacity: 0.5;
            background-color: transparent;
        }
    }

    .MuiAutocomplete-clearIndicator {
        &:hover {
            opacity: 0.5;
            background-color: transparent;
        }
    }

    .MuiAutocomplete-popupIndicatorOpen {
        transform: rotate(90deg);
    }

    .MuiAutocomplete-inputRoot {
        .MuiAutocomplete-input {
            border: 0;
        }
    }

    .MuiInputBase-input.MuiInputBase-inputAdornedEnd {
        padding: 0;
        ${(props) => props.theme.typography.smallTextBold}
    }

    .MuiInputBase-root {
        &.Mui-disabled {
            border: 1px solid ${(props) => props.theme.palette.primaryA4};
            background-color: ${(props) => props.theme.palette.primaryA6};

            [aria-expanded='true'] {
                border-radius: 8px 8px 0 0;
            }

            .MuiInputBase-input {
                caret-color: transparent;
                cursor: pointer;

                &::placeholder {
                    ${(props) => props.theme.typography.smallTextBold}
                    color: ${(props) => props.theme.palette.textLight};
                    opacity: 1;
                }
            }
        }
    }

    .MuiAutocomplete-root {
        .MuiInputBase-root {
            max-height: none;
        }
    }

    .MuiInputBase-root .Mui-focused {
        .MuiInputBase-root {
            border: 1px solid ${(props) => props.theme.palette.primaryA1};
        }
    }

    [aria-owns] {
        .MuiInputBase-root {
            border: 1px solid ${(props) => props.theme.palette.primaryA1};
        }
    }
    .MuiAutocomplete-hasPopupIcon {
        .MuiAutocomplete-inputRoot {
            padding-right: 0;
        }

        &.MuiAutocomplete-hasClearIcon {
            .MuiOutlinedInput-root {
                padding-right: 45px;
            }
        }
    }

    .MuiOutlinedInput-root {
        .MuiAutocomplete-endAdornment {
            top: 50%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }
    }

    .MuiChip-root {
        background-color: ${(props) => props.theme.palette.primaryA1};
        color: ${(props) => props.theme.palette.primaryA7};
        height: 24px;
    }
`;
